import Well from '../modules/components/Well';

export default Well;



// WEBPACK FOOTER //
// ./src/components/Well.js